var _style, _path, _g, _g2, _path2, _g3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 98",
    style: {
      enableBackground: "new 0 0 75 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle-Copy-13_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00ACFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#00D5ED;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#path-7_2_);}\n\t.st6{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:#00ACFF;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HB---Dashboard---First-Login",
    transform: "translate(-23.000000, -417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule-your-next-visit---Card",
    transform: "translate(16.000000, 361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar-Illustration",
    transform: "translate(24.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-Copy-13_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -272.7387,
    y1: 462.5833,
    x2: -272.2361,
    y2: 462.3125,
    gradientTransform: "matrix(74.4423 0 0 -54.6538 20323.7969 25314.9414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D4EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08E9DB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-13",
    className: "st0",
    d: "M-2.9,5.7h46.8c7.8,0,14.1,6.3,14.1,14v26.7c0,7.7-6.3,14-14.1,14H-2.9 c-7.8,0-14.1-6.3-14.1-14V19.7C-17,11.9-10.7,5.7-2.9,5.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st1",
    d: "M-2.7,23.6h46.4c7.7,0,14,6.3,14,14V84c0,7.7-6.3,14-14,14H-2.7c-7.7,0-14-6.3-14-14V37.6 C-16.7,29.8-10.5,23.6-2.7,23.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2_1_",
    className: "st2",
    d: "M-2.9,23.6h46.8c7.8,0,14.1,6.3,14.1,14V84c0,7.7-6.3,14-14.1,14H-2.9 C-10.7,98-17,91.7-17,84V37.6C-17,29.8-10.7,23.6-2.9,23.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "st1",
    d: "M-17,69.7h12.4c7.7,0,14,6.3,14,14V98l0,0H-2.9c-7.7,0-13.9-6.2-14-13.9L-17,69.7L-17,69.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-4_1_",
    className: "st3",
    d: "M-17,69.7h12.4c7.7,0,14,6.3,14,14V98l0,0H-2.9c-7.7,0-13.9-6.2-14-13.9L-17,69.7 L-17,69.7z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_x33_1",
    className: "st4",
    d: "M6.8,81C14.9,81,20,76.3,20,70c0-5-4.3-8.5-7.1-9.6v-0.2c2.6-1.2,6-4.6,6-9.1 c0-6.5-5.4-10.6-12.2-10.6C0.4,40.5-4,45.6-4,45.6c-0.4,0.4-0.5,1.1,0,1.5l2.2,1.9c0.5,0.5,1.2,0.3,1.5-0.1 c1.2-1.3,3.3-3.2,6.8-3.2c3.4,0,6.7,2.4,6.7,6.3c0,3.4-2.7,6.2-8.2,6.2H1.6c-0.8,0-1.2,0.3-1.2,1.2v2.5c0,0.8,0.5,1.2,1.1,1.2 h3.3c6.2,0,9.2,3.3,9.2,6.8c0,3.9-3.5,6.3-7.3,6.3c-4.3,0-7.6-3.1-7.9-3.6c-0.5-0.5-1-0.6-1.6-0.1l-2.3,2.1 c-0.4,0.3-0.4,1-0.1,1.4C-3.9,77.4-0.4,81,6.8,81z M36.9,80.3c0.6,0,1.1-0.5,1.1-1.1V42.3c0-0.6-0.5-1.1-1.1-1.1h-2.9l-8.5,7.4 c-0.2,0.2-0.4,0.7-0.2,1.1l0.7,2c0.2,0.5,0.8,0.6,1.3,0.4l4.8-2.2v29.2c0,0.6,0.5,1.1,1.1,1.1H36.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-22-Copy-2",
    transform: "translate(13.192308, 83.865385) rotate(-90.000000) translate(-13.192308, -83.865385) "
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    className: "st1",
    d: "M-0.9,80.1l28.3-26.4v12.4c0,7.7-6.3,14-14,14H-0.9L-0.9,80.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path-7_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -363.1412,
    y1: -218.4861,
    x2: -362.6412,
    y2: -218.0506,
    gradientTransform: "matrix(0 26.3846 28.2692 0 6189.6265 9648.2051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D4EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08E9DB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-7_1_",
    className: "st5",
    d: "M-0.9,80.1l28.3-26.4v12.4c0,7.7-6.3,14-14,14H-0.9L-0.9,80.1z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_",
    className: "st6",
    d: "M-2.6,0L-2.6,0C-1,0,0.2,1.3,0.2,2.8v12.2c0,1.6-1.3,2.8-2.8,2.8h0 c-1.6,0-2.8-1.3-2.8-2.8V2.8C-5.4,1.3-4.1,0-2.6,0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-14",
    className: "st6",
    d: "M42.6,0L42.6,0c1.6,0,2.8,1.3,2.8,2.8v12.2c0,1.6-1.3,2.8-2.8,2.8l0,0 c-1.6,0-2.8-1.3-2.8-2.8V2.8C39.8,1.3,41.1,0,42.6,0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.48138b019e24e68aa3bfca0ce8132ee7.svg";
export { ForwardRef as ReactComponent };